import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../config/api';

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const sessionId = localStorage.getItem('sessionId');
      const response = await axios.post(`${BASE_URL}auth/logout`, {}, {
        headers: {
          'session-id': sessionId || '',
        },
      });
      if (response.status === 200) {
        console.log("Logout successful", response);
        // Clear localStorage
        localStorage.removeItem('sessionId');
        localStorage.removeItem('userId');
        localStorage.removeItem('token');
        // Clear cart and order data
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('cart') || key.startsWith('order')) {
            localStorage.removeItem(key);
          }
        });
        navigate('/Homepage');
      } else {
        console.error('Logout failed:', response.data.error);
        throw new Error('Logout failed');
      }
    } catch (error) {
      console.error('Error logging out:', error);
      throw error;
    }
  };

  return logout;
};

export default useLogout;
